import { format } from "d3";

/**
 * @param {{features:{}}} geoData
 */
export let geoData = {
	features: {},
};
/**
 * @param {{features:{}}} geoDataUsa
 */
export let geoDataUsa = {
	features: {},
};

/**
 * @param {string} id
 */
export function getFeature(id) {
	let feature = geoData.features[id];
	if (!feature)
		// feature = geoDataUsa.features["united-states-of-america"];
		feature = geoDataUsa.features[Object.keys(geoDataUsa.features)[0]];
	return feature;
}

export function getMetric(metrics, id) {
	return metrics.find((metric) => metric.id == id);
}

export function getValues(feature, metric) {
	if (!metric) return null;
	if (!feature) feature = geoDataUsa.features["united-states-of-america"];
	return {
		value: feature.properties[metric.id],
		formatted: feature.formatted[metric.id],
	};
}

export function getFormatted(value) {
	let formatted;
	if (value < 100) formatted = format(".0f")(value);
	// 2f=1.00 0f=1
	else if (value < 1000) formatted = format(".0f")(value);
	else if (value < 100000) formatted = format(",.3r")(value);
	else if (value < 1000000) formatted = format(",.4r")(value);
	else if (value < 100000000) formatted = format(".2s")(value);
	else formatted = format(".2s")(value).replace("G", "B");

	// formatted = formatted; // why???
	// formatted = format("$,.0f")(value);
	return formatted;
}

const a =
	"àáâäæãåāăąçćčđďèéêëēėęěğǵḧîïíīįìłḿñńǹňôöòóœøōõőṕŕřßśšşșťțûüùúūǘůűųẃẍÿýžźż·/_,:;";
const b =
	"aaaaaaaaaacccddeeeeeeeegghiiiiiilmnnnnoooooooooprrsssssttuuuuuuuuuwxyyzzz------";
const p = new RegExp(a.split("").join("|"), "g");
export function slugify(string) {
	return string
		.toString()
		.toLowerCase()
		.replace(/\s+/g, "-") // Replace spaces with -
		.replace(p, (c) => b.charAt(a.indexOf(c))) // Replace special characters
		.replace(/&/g, "-and-") // Replace & with 'and'
		.replace(/[^\w\-]+/g, "") // Remove all non-word characters
		.replace(/\-\-+/g, "-") // Replace multiple - with single -
		.replace(/^-+/, "") // Trim - from start of text
		.replace(/-+$/, ""); // Trim - from end of text
}
